import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=2824ac5d&scoped=true"
import script from "./Remove.vue?vue&type=script&lang=js"
export * from "./Remove.vue?vue&type=script&lang=js"
import style0 from "./Remove.vue?vue&type=style&index=0&id=2824ac5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824ac5d",
  null
  
)

export default component.exports